import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { Favorite } from "grommet-icons"
import React from "react"
import styled from "styled-components"
import getGatsbyImage from "utils/getGatsbyImage"
import Button from "../../UI/Button"

const Wrapper = styled.div`
  position: relative;
  min-height: 300px;
  > :first-child {
    position: absolute !important;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    z-index: -1;
  }
  padding: 25px 0;
`

const Card = styled.div`
  max-width: 280px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 12px;
  padding: 25px 10px;
  border: 2px solid ${(props: any) => props.theme.primary};
  text-align: center;
  > :first-child {
    color: ${(props: any) => props.theme.secondary};
    font-size: 1.3em;
    line-height: 1.1;
    margin-bottom: 30px;
    font-weight: bold;
  }
  > :nth-child(2) {
    margin-bottom: 20px;
  }
`

const Sam = styled.div`
  position: relative;
  height: 110px;
  width: 100%;
  margin-top: 0px;
  pointer-events: none;
  > :first-child {
    position: absolute !important;
    height: 145% !important;
    transform: translateX(-50%) translateY(8px);
    width: 100%;
  }
  img {
    object-fit: contain !important;
  }
`

const Points = styled.div`
  padding-top: 40px;
  display: flex;
  color: #fff;
  font-weight: bold;
  justify-content: center;
  > * {
    margin-right: 14px;
  }
  > :last-child {
    margin-right: 0;
  }
`

const Point = styled.div`
  display: flex;
  align-items: center;
  > :first-child {
    margin-right: 8px;
    * {
      fill: #98c355;
    }
  }
`

interface IProps {
  backgroundImage: any
  title: string
  description: string
  button: {
    value: string
    targetUrl: string
  }
  bulletItems: {
    bulletIcon: any
    value: string
  }[]
}

const TeacherCTAHero = (props: IProps) => (
  <Wrapper className='TeacherCTAHero'>
    <GatsbyImage
      image={getGatsbyImage(props.backgroundImage.localFile)}
      alt=""
    />
    <Card>
      <div>{props.title}</div>
      <div>{props.description}</div>
      <Link to={props.button.targetUrl}>
        <Button theme="primary" size="small">
          {props.button.value}
        </Button>
      </Link>
      <Sam>
        <StaticImage
          src="../../../images/characters/sam-head.png"
          alt="Sam"
          placeholder="blurred"
        />
      </Sam>
    </Card>
    {props.bulletItems && (
      <Points>
        {props.bulletItems.map((p, i) => (
          <Point key={i}>
            <Favorite color="#98C355" />
            <div>{p.value}</div>
          </Point>
        ))}
      </Points>
    )}
  </Wrapper>
)

export default TeacherCTAHero
